import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository'
import type { DashboardClassroomModuleResult } from '@/core/domain/dashboard/DashboardClassroomStudentResult'

/**
 * Use case pour récupérer les résultats de modules d'une classe
 */
export class FetchClassroomModuleResultsUseCase {
  private dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(
    schoolId: number,
    periodId: number,
    schoolClassroomId: number
  ): Promise<DashboardClassroomModuleResult[]> {
    return await this.dashboardRepository.fetchClassroomModuleResults(
      schoolId,
      periodId,
      schoolClassroomId
    )
  }
}
